import { render, staticRenderFns } from "./userdetail.vue?vue&type=template&id=fcf3053e&scoped=true&"
import script from "./userdetail.vue?vue&type=script&lang=js&"
export * from "./userdetail.vue?vue&type=script&lang=js&"
import style0 from "./userdetail.vue?vue&type=style&index=0&id=fcf3053e&prod&scoped=true&lang=css&"
import style1 from "./userdetail.vue?vue&type=style&index=1&id=fcf3053e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf3053e",
  null
  
)

export default component.exports